import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle"
import Home from "./Components/About/Home"
import About from "./Components/About/About"
import Contact from "./Components/Contact/Contact"
import Service from "./Components/Project/Service"
import Navbar from "./Components/Navbar/Navbar"
import Education from "./Components/Education/Education"
import Achievement from "./Components/Achievement/Achievement"
import Skills from "./Components/Skills/Skills"
import Exp from "./Components/Experience/Exp.jsx"
import Footer from "./Components/Footer/Footer"
import { Switch, Route, Redirect } from "react-router-dom"
function App() {
  return (
    <div>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/contactme" component={Contact} />
        <Route exact path="/project" component={Service} />
        <Route exact path="/education" component={Education} />
        <Route exact path="/experience" component={Exp} />
        <Route exact path="/skill" component={Skills} />
        <Route exact path="/achievement" component={Achievement} />
        <Redirect to="/" />
      </Switch>
      <Footer />
    </div>
  )
}

export default App
